"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDates = normalizeDates;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
/**
 * `normalize-dates` migration — rewrite any doc whose `created` / `updated` is not
 * canonical `YYYY-MM-DD` (e.g. a legacy full-ISO timestamp) to canonical form.
 *
 * This is hygiene, NOT a correctness dependency: `toEpoch` already orders mixed
 * formats correctly, so History and staleness are right whether or not this runs.
 * It only makes on-disk dates uniform. Idempotent (re-running over canonical docs
 * changes nothing) and `--dry-run` capable. The actual canonicalization happens in
 * `serializeFrontmatter` on save — load → save is the blessed round-trip and parses
 * plan steps correctly, so a re-save never corrupts a plan's structured steps.
 *
 * Archived docs (`loom/.archive/**`) are frozen and skipped.
 */
const DATE_FIELDS = ['created', 'updated'];
async function walkMarkdown(dir, fs) {
    const out = [];
    const entries = await fs.readdir(dir).catch(() => []);
    for (const name of entries) {
        if (name === '.archive' || name === 'node_modules' || name === '.git')
            continue;
        const full = path.join(dir, name);
        const st = await fs.stat(full).catch(() => null);
        if (!st)
            continue;
        if (st.isDirectory()) {
            out.push(...(await walkMarkdown(full, fs)));
        }
        else if (name.endsWith('.md')) {
            out.push(full);
        }
    }
    return out;
}
async function normalizeDates(opts, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const docsDir = path.join(loomRoot, 'loom');
    const dryRun = !!opts.dryRun;
    const changed = [];
    const failed = [];
    let scanned = 0;
    if (!(await deps.fs.pathExists(docsDir)))
        return { changed, scanned, failed, dryRun };
    const files = await walkMarkdown(docsDir, deps.fs);
    for (const file of files) {
        scanned++;
        try {
            const doc = (await deps.loadDoc(file));
            let needsWrite = false;
            for (const field of DATE_FIELDS) {
                const cur = doc[field];
                if (typeof cur !== 'string' || cur === '')
                    continue;
                const canon = (0, dist_1.toCanonical)(cur);
                if (canon !== cur) {
                    changed.push({ path: path.relative(loomRoot, file), field, from: cur, to: canon });
                    doc[field] = canon;
                    needsWrite = true;
                }
            }
            if (needsWrite && !dryRun)
                await deps.saveDoc(doc, file);
        }
        catch (e) {
            failed.push({ path: path.relative(loomRoot, file), error: e?.message ?? String(e) });
        }
    }
    return { changed, scanned, failed, dryRun };
}
